import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import "./index.scss";
import { Modal } from "react-bootstrap";
// import backicon from "../../../../../Assets/icons/backIcon.svg";
import backicon from "../../../../../Assets/icons/backIcon.svg"
import axiosInstance from "../../../../services/api/API";
// import axiosInstance from "../../../../../http.common";
// import downloadIcon from "../../../../../Assets/icons/download.svg";
// import plusIcon from "../../../../../Assets/icons/plus-circle.svg";
// import MinusIcon from "../../../../../Assets/icons/Minus-circle.svg";
// import axiosInstance from "../../../../services/api/API";
// import Switch from "react-switch";
// import CustomTable from "../../../../customComponents/CustomTable";
//plus-circleimport Switch from "react-switch";.svg Minus-circle.svg

const ProposalInvoice = () => {
  const location = useLocation();
  const { data } = location.state || {};

  const navigate = useNavigate();
  // const { jobCardDataDetails } = location?.state || {};
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [selectedAssignee, setSelectedAssignee] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [showRemarkModal, setShowRemarkModal] = useState(false); // Add state for remark modal
  const [remark, setRemark] = useState("");
  const token = localStorage.getItem("authToken");
  const [jobCardDetails, setJobCardDetails] = useState();
  const [jobCardIssueList, setJobCardIssueList] = useState([]);
  const [invoiceData,setInvoiceData] = useState()

  const [ custDetailsVal , setCustDetailsVal ] = useState([])
  const [ financeDetails , setFinanceDetails ] = useState([])
  const [proposalPartDetails, setProposalPartDetails] = useState([]);


  // Add state for remark
  const [assigneeList] = useState([
    { name: "Telecaller 1", assignedLeads: 5 },
    { name: "Telecaller 2", assignedLeads: 10 },
    { name: "Telecaller 3", assignedLeads: 3 },
    { name: "Sales Manager 1", assignedLeads: 8 },
    { name: "Sales Manager 2", assignedLeads: 6 },
    { name: "Sales Manager 3", assignedLeads: 2 },
  ]);
  const [issueId, setIssueId] = useState(0);

  const Job_Card_TABLE_HEADERS = [
    "Complain",
    "Quantity",
    "Price",
    "Total_Cost",
  ];
  const BUSINESS_PARTNER_KEY_MAPPING = {
    Complain: "item_name",
    Quantity: "good_qty",
    Price: "item_total_amount",
    Total_Cost: "item_total_amount",
  };
  const [filteredAssigneeList, setFilteredAssigneeList] =
    useState(assigneeList);

  useEffect(() => {
    fetchProposalInvoiceDetails()
  },[])

  const fetchProposalInvoiceDetails = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/proposal/proposalDetails",
        {
          business_partner_id: 1,
          proposal_id: data.proposal_id,
        
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formatedData = response?.data?.data
      console.log(formatedData, "formatedData")

      const custDetails = formatedData.proposalDetailsList[0]
      console.log(custDetails, "custdetails")
      setCustDetailsVal(custDetails)

      setProposalPartDetails(formatedData.proposalPartDetails);

      const financeDetails = formatedData.financeDetails[0]
      setFinanceDetails(financeDetails)

      setInvoiceData({
        SubTotal: formatedData.subTotal, 
        Gst: formatedData.taxPercent, 
        GstAmount: formatedData.gst, 
        Total: formatedData.total 
      });

 
  //     setJobCardIssueList(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const GenerateInvoiceDetails = async () => {
    try {
      const response = await axiosInstance.post(
        "/proposalinvoice/create",
        {
          business_partner_id: 1,
          proposal_id:data.proposal_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // if (response?.status == 200) {
      //   navigate("/manage-services/job-card-invoice");
      // }
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const backNavigation = () => {
    navigate("/manage-sales/proposal")
  }

  return (
    <div>
      <div className="OnboardManagamentContainer ">
        <div className="OnboardManagamentbuttonContainer  col-xl-4 col-lg-12 mt-2 mb-2">
          <div className="backbutton mt-2 mb-2">
            <img src={backicon} alt="back" onClick={backNavigation} />
            <span className="backbtntitle">Invoice Details</span>
          </div>
        </div>
        <div className="totalvaluescontainer col-xl-8 col-lg-12 mt-2 mb-2">
          <div
          style={{cursor:"pointer"}}
            className="downloadiconwrapper downloadIcon"
            onClick={() => GenerateInvoiceDetails()}
          >
            <h6 className="downloadTitle">Generate Invoice</h6>
          </div>
        </div>
      </div>
      <div className="invoice-container mt-3">
        <header className="invoice-header ">
          <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}} className="row first-row">
            <img
              src="https://html.laralink.com/invoma/assets/img/logo.svg"
              alt="Company Logo"
              className="company-logo"
            />
            <span className="invoiceheader">Invoice</span>
          </div>
          <div className="row second-row">
            <div className="payment-method">
              {/* <span className='pmtitle'>Payment Method:</span><span className='pmvalue'> Credit Card</span> */}
            </div>
          </div>
        </header>
        <div className="addresssections">
          <section className="invoice-details">
            <div style={{ textAlign: "left" }}>
              <h2>Invoice To:</h2>
              <p className="addvalue">{custDetailsVal?.customer_name || "-"}</p>
              <p className="addvalue">
                {custDetailsVal?.address || "-"} ,
                {custDetailsVal?.showroom_pincode || "-"}
              </p>

              <p className="addvalue">
                {custDetailsVal?.email_id || "-"}, <b>Contact No.-</b>
                {custDetailsVal?.mobile_no || "-"}
              </p>
            </div>
          </section>
          <section className="invoice-details">
            <div style={{ textAlign: "right" }}>
              <h2>Pay To:</h2>
              <p className="addvalue">{custDetailsVal?.showroom_name || "-"}</p>
              <p className="addvalue">{custDetailsVal?.showroom_address || "-"}</p>
              <p className="addvalue">
                {custDetailsVal?.bp_stashowroom_state_namete_name || "-"}-
                {custDetailsVal?.showroom_city_name || "-"}-{" "}
                {custDetailsVal?.showroom_pincode || "-"}
              </p>
              <p className="addvalue">
                {custDetailsVal?.showroom_emailid || "-"}, <b>Contact No.-</b>
                {custDetailsVal?.showroom_contact_no || "-"}
              </p>
            </div>
          </section>
        </div>
        <table className="invoice-table">
          <thead>
            <tr>
              <th>Product</th>
              <th>Sub-Product</th>
              <th>Make</th>
              <th>Model</th>
              <th>Color</th>
              <th>Fuel</th>
            </tr>
          </thead>
          <tbody>
            {/* {(jobCardIssueList || []).map((jobcardData) => ( */}
              <tr>
                <td>{custDetailsVal?.product_name || "-"}</td>
                <td>{custDetailsVal?.subproduct_name}</td>
                <td> {custDetailsVal?.make_name}</td>
                <td> {custDetailsVal?.model_name}</td>
                <td> {custDetailsVal?.color_name}</td>
                <td> {custDetailsVal?.fuel_type_name}</td>
              </tr>
            {/* ))} */}
          </tbody>
        </table>

        {/* Finance */}
        <table className="invoice-table">
          <thead>
            <tr>
            <th>Financer Name</th>
              <th>Financer City</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {/* {(jobCardIssueList || []).map((jobcardData) => ( */}
              <tr>
                <td>{financeDetails?.financer_name || "-"}</td>
                <td>{financeDetails?.city_name}</td>
                <td>&#8377; {financeDetails?.finance_amount}</td>
              </tr>
            {/* ))} */}
          </tbody>
        </table>

        {/* Addition of product */}

        <table className="invoice-table">
          <thead>
            <tr>
              <th>Item </th>
              <th>Quantity </th>
              <th>Unit Price</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
          {(proposalPartDetails || []).map((item, index) => (
      <tr key={index}>
        <td>{item?.item_name || "-"}</td>
        <td>{item?.quantity || "-"}</td>
        <td>&#8377; {item?.rate || "-"}</td>
        <td>&#8377; {item?.item_total || "-"}</td>
      </tr>
    ))}
          </tbody>
        </table>


        <footer className="invoice-footer">
          <div className="pminfo"></div>
          <div className="total">
                <div className="totalval">
                  <span>Subtotal:</span>
                  <span>&#8377;{Number(invoiceData?.SubTotal).toFixed(2) || '-'}</span>
                </div>
                <div className="totalval">
                  <span>Tax ({invoiceData?.Gst || '0'}%):</span>
                  <span>&#8377;{Number(invoiceData?.GstAmount).toFixed(2) || '0'}</span>
                </div>
                <div className="grandtotal">
                  <span>Grand Total: </span>
                  <span>&#8377;{Number(invoiceData?.Total).toFixed(2) || '0'}</span>
                </div>
              </div>
        </footer>
      </div>
    </div>
  );
};

export default ProposalInvoice;
